import React from "react";
import {BsCheckCircle, BsClock, BsCreditCard2Front, BsInfoCircle, BsX, BsXCircle} from "react-icons/bs";
import {MANUAL_PAYMENT_STATUSES} from "./manualPaymentModel";
import "./manual-payment.css";

export function ManualPaymentStatus({status}) {
  const definition = MANUAL_PAYMENT_STATUSES[status];
  const Icon = status === "success" ? BsCheckCircle : status === "failure" ? BsXCircle : BsClock;
  return <span className={`manual-payment-status is-${definition ? status : "unknown"}`}>
    <Icon aria-hidden="true"/>{definition?.label || "نامشخص"}
  </span>;
}

export function ManualPaymentDialogHeading({title, subtitle, onClose, disabled}) {
  return <div className="manual-payment-dialog-heading" dir="rtl">
    <span className="manual-payment-icon"><BsCreditCard2Front aria-hidden="true"/></span>
    <div className="min-w-0 flex-1"><h2>{title}</h2><p>{subtitle}</p></div>
    <button type="button" aria-label="بستن پنجره" onClick={onClose} disabled={disabled} className="manual-payment-close"><BsX aria-hidden="true"/></button>
  </div>;
}

export function ManualPaymentNotice({children}) {
  return <div className="manual-payment-notice"><BsInfoCircle aria-hidden="true"/><p>{children}</p></div>;
}
